import React, { useState, useEffect } from "react";
import { Table, Card, Button, Spinner, Alert } from "react-bootstrap";
import { FaPrint, FaSync } from "react-icons/fa";
import api from "../../axiosConfig";

export default function RaportConsumProd() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchData = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await api.get("/comenzi-prod/rapoarte/consum-teoretic-real");
      setData(res.data);
    } catch (err) {
      console.error(err);
      setError("Eroare la încărcarea raportului.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4>Rețetă și materiale transferate (Producție)</h4>
        <div>
          <Button variant="outline-secondary" className="me-2" onClick={fetchData} disabled={loading}>
            <FaSync className="me-1" /> Actualizează
          </Button>
          <Button variant="primary" onClick={() => window.print()} className="d-print-none">
            <FaPrint className="me-1" /> Printează
          </Button>
        </div>
      </div>
      <p className="text-muted">Compară necesarul comenzii cu materialele transferate în producție. Consumul efectiv se verifică pe bonul de producție.</p>
      <Card className="shadow-sm border-0">
        <Card.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          {loading ? (
            <div className="text-center py-5"><Spinner animation="border" variant="primary" /></div>
          ) : (
            <div className="table-responsive">
              <Table bordered hover striped className="align-middle text-center">
                <thead className="table-light">
                  <tr>
                    <th>Cmd / Data</th>
                    <th>Produs Finit</th>
                    <th>Materie Primă</th>
                    <th>Necesar (Rețetă)</th>
                    <th>Cantitate transferată</th>
                    <th>Diferență</th>
                    <th>Extra?</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((row, idx) => (
                    <tr key={idx}>
                      <td>#{row.comanda} <br/><small className="text-muted">{row.data}</small></td>
                      <td>{row.produs_finit}</td>
                      <td className="text-start">{row.materie_prima}</td>
                      <td>{Number(row.necesar_teoretic).toFixed(2)}</td>
                      <td className="fw-bold text-primary">{Number(row.consum_real).toFixed(2)}</td>
                      <td className={`fw-bold ${row.diferenta > 0 ? 'text-danger' : row.diferenta < 0 ? 'text-success' : ''}`}>
                        {row.diferenta > 0 ? '+' : ''}{Number(row.diferenta).toFixed(2)}
                      </td>
                      <td>{row.is_extra ? <span className="badge bg-warning">DA</span> : "-"}</td>
                    </tr>
                  ))}
                  {data.length === 0 && <tr><td colSpan="7" className="text-center text-muted py-4">Nu există date.</td></tr>}
                </tbody>
              </Table>
            </div>
          )}
        </Card.Body>
      </Card>
      <style>{`
        @media print {
          .d-print-none, .navbar, .sidebar { display: none !important; }
          body { background: white; padding: 0; margin: 0; }
          .container-fluid { padding: 0; }
          .card { border: none !important; box-shadow: none !important; }
        }
      `}</style>
    </div>
  );
}
